<template>
	<!-- 我的订单 -->
	<div>
		<!-- <ul class="order_center_title">
			<li>标的标题</li>
			<li>当前价</li>
			<li>开始时间</li>
			<li>结束时间</li>
		</ul>
		<ul class="order_center_text">
			<li v-for="(item,index) in products" :key="index">
				<router-link :to="{ path:'/biaodiDetails',query:{ id:item.id }}" class="order_center_text_li">
					<span>{{item.title}}</span>
					<span>{{item.price}}</span>
					<span>{{item.created_at}}</span>
					<span>{{item.end_time}}</span>
				</router-link>
			</li>
		</ul> -->
		<ul class="love_box">
			<li class="love_list c_gray f12"  v-for="(item,index) in collect" :key="index">
				<router-link :to="{path:'/biaodiDetails',query:{ id:item.id }}" class="c_gray f12">
				<div class="love_img" :style="{'backgroundImage':'url('+item.img+')'}"></div>
				<p>编号：[{{item.id}}]</p>
				<p>起拍价：<span class="f20 cj_price c_red">{{item.pirce}}</span>元</p>
				<p>拍卖时间：{{item.start_at}}</p>
				<p>所在地：{{item.province}}</p>
				<!-- <div class="cj_price c_gray see_person love_person">
					<img src="@/assets/images/see1.png" alt="">{{item.sign_count}}报名 | <img src="@/assets/images/see2.png" alt="">{{item.view_count}}围观
				</div>
				<span class="love_state">进行中</span> -->
				</router-link>
			</li>

		</ul>
	</div>
</template>

<script>
export default {
	name: 'Orders',
	// inject: ['reload'],
	data (){
		return{
			token: localStorage.getItem('apiToken'),
			collect: []
		}
	},
	created(){
		 // 请求页面数据
		this.axios.get(this.$global.apiUrl.collect, {
			params: {
			apiToken: this.token
			}
		})
		.then((response) => {
			console.log(response.data)
			if(response.data.error.code == 0){
				this.collect = response.data.favorite;
			}
		})
		.catch(() => {
				// console.log(response.data.error.message)
		})
		

	},
	watch:{
		
	},
	mounted(){

	},
	computed: {

	},
	methods: {
		
	}
}
</script>